import { ConnectionNames } from "../../../Contracts";
import { createRESTConn } from "../../../Common";
import { BetSlipRequestFormatter } from "../BetSlipRequestFormatter";
export function createBetSlipConnection() {
    return createRESTConn({
        name: ConnectionNames.betslip,
        handlers: {
            requestFormatter: BetSlipRequestFormatter
        }
    });
}
//# sourceMappingURL=CreateBetSlipConnection.js.map